import axios from "@axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get("/admin/f/users", { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/admin/f/users/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addUser(ctx, userData) {
      userData.username = userData.email;
      userData.roles = ["ROLE_MANAGER"];

      return new Promise((resolve, reject) => {
        axios
          .post("/admin/auth/createadminuser", userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateUser(ctx, userData) {
      userData.username = userData.email;

      return new Promise((resolve, reject) => {
        axios
          .post(`/admin/auth/updateadminuser`, userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    deleteUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/admin/auth/deleteadminuser`, userData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
